import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../../../services/api";
import functions from "../../../util/functions";
import ListFilter from "../../filter/ListFilter";
import FilterModal from "../../filter/Modal";
import ReceiveModal from "../ModalReceive";
import RegisterAuthModal from "../ModalRegister";

import "./style.css";
import reqAuthFinancas from "../../../services/reqAuthFinancas";

function ListContaEntradaSZ() {
	const [idCliente, setIdCliente] = useState("");
	const [idContaEntrada, setIdContaEntrada] = useState("");
	const [nome, setNome] = useState("");
	const [valortotal, setValorTotal] = useState(0);
	const [descricao, setDescricao] = useState("");
	const [dtini, setDtIni] = useState(new Date());
	const [dtfim, setDtFim] = useState(new Date());

	const [loading, setLoading] = useState(false);
	const [sucesso, setSucesso] = useState("");
	const [atrasados, setAtrasados] = useState(true);

	const [listaContaEntrada, setlistaContaEntrada] = useState([]);

	const [isFilterOpen, setIsFilterOpen] = useState(false);
	const [isRegisterOpen, setIsRegisterOpen] = useState(false);
	const [isReceiveOpen, setIsReceiveOpen] = useState(false);

	const [tipoData, setTipoData] = useState("dtVencimento");
	const [selectedLabel, setSelectedLabel] = useState("Data de Vencimento");

	const [loadList, setLoadList] = useState(false);

	const banco = functions.databaseConfig();

	const optionsToast = {
		position: "top-center",
		autoClose: 2000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	};

	useEffect(() => {
		if (loadList) listarContaEntrada();
	}, [loadList]);

	useEffect(() => {
		const valor = functions.iniFimMes();
		setDtIni(valor.inicioMes);
		setDtFim(valor.fimMes);
	}, []);

	const carregarListas = () => {
		setLoadList(true);
		closeFilter();
	};

	function message(type, message) {
		if (type === "success") {
			let campo = `Salvo com sucesso`;
			toast.success(campo, optionsToast);
		} else if (type === "error") {
			let campo = ` ${message} `;
			toast.warn(campo, optionsToast);
		}
	}

	function listarContaEntrada() {
		closeFilter();
		setSucesso("");
		setLoading(true);
		let valorTotal = 0;
		let list = [];

		const bd = functions.databaseConfig();

		api.get("v2/auth/contaentrada/listar", {
			params: {
				nome,
				dtini,
				dtfim,
				atrasados,
				tipoData,
			},
			headers: {
				banco: bd,
			},
		})
			.then((response) => {
				const { data, status } = response;

				if (status == 200 || status == 201) {
					if (data && data.length > 0) {
						list = data;
						valorTotal = data[0].valortotal;
					}
				}
			})
			.catch((err) => {
				let erro;
				if (!err == undefined) {
					erro = `Verifique os dados e tente novamente, ${err.response.response}`;
				} else {
					erro = "Servidor não alcançado, tente novamente";
				}

				setlistaContaEntrada([]);
				message("error", erro);
			})
			.finally(() => {
				setLoadList(false);
				setLoading(false);
				setValorTotal(valorTotal);
				setlistaContaEntrada(list);
			});
	}

	const handleRadioChangeData = (value, label) => {
		setTipoData(value);
		setSelectedLabel(label);
	};

	function openFilter() {
		setIsFilterOpen(!isRegisterOpen);
	}

	function openRegister() {
		setIsRegisterOpen(!isFilterOpen);
	}
	function openReceive() {
		setIsReceiveOpen(!isFilterOpen);
	}

	/* FECHA O MODAL */
	function closeFilter() {
		setIsFilterOpen(false);
	}

	/* FECHA O MODAL Cadastro*/
	function closeRegisterModal() {
		setIsRegisterOpen(false);
		// listarContaEntrada();
	}

	function closeReceiveModal() {
		setIsReceiveOpen(false);
	}

	function clickRegister(ce) {
		if (ce.id_cliente === 1) {
			message("error", "Não é possível abrir registro, cliente consumidor final");
			return;
		}

		setIdContaEntrada(ce.id_conta_entrada);
		setIdCliente(ce.id_cliente);
		setDescricao(ce.descricao);

		openRegister();
	}

	function clickReceive(ce) {
		setIdContaEntrada(ce.id_conta_entrada);
		openReceive();
	}

	return (
		<>
			<ToastContainer />
			<FilterModal //
				title={"Recebimentos"}
				isOpen={isFilterOpen}
				onRequestClose={closeFilter}
				filterName={true}
				filterLate={true}
				nome={nome}
				dtini={dtini}
				dtfim={dtfim}
				atrasados={atrasados}
				setDtIni={setDtIni}
				setDtFim={setDtFim}
				setNome={setNome}
				setAtrasados={setAtrasados}
				tipoPesquisaNome="Cliente"
				handleList={carregarListas}
				filterData={true}
				tipoData={handleRadioChangeData}
			/>

			<RegisterAuthModal //
				isOpen={isRegisterOpen}
				onRequestClose={closeRegisterModal}
				idCliente={idCliente}
				nome={descricao}
				message={message}
				listar={carregarListas}
			/>

			<ReceiveModal //
				isOpen={isReceiveOpen}
				onRequestClose={closeReceiveModal}
				idContaEntrada={idContaEntrada}
				message={message}
				listar={carregarListas}
			/>

			<div className="content-fluid mt-page">
				<h1>Listar Recebimentos</h1>
				<ListFilter //
					nome={nome}
					dtini={functions.dateByString(dtini)}
					dtfim={functions.dateByString(dtfim)}
					atrasados={atrasados}
					count={listaContaEntrada.length}
					valortotal={valortotal}
					tipoData={selectedLabel}
				/>

				<div className="d-flex align-items-center justify-content-end">
					<button className="btn btn-sm btn-primary w-25 " onClick={openFilter}>
						Listar
					</button>
				</div>
				{loading ? (
					<div className="loading text-center h-100 m-5">
						<div>
							<span className="spinner-grow spinner-grow-sm text-primary me-2" role="status"></span>
							<span className="text-primary">Buscando Dados...</span>
						</div>
					</div>
				) : (
					<div className="table-responsive">
						<table className="table mt-3">
							<thead>
								<tr>
									<th scope="col">Nome</th>
									<th scope="col">Valor</th>
									<th scope="col">PG.</th>
									<th scope="col">Autorização</th>
									<th scope="col">Vencimento</th>
									<th scope="col">Dt.Venda</th>
								</tr>
							</thead>

							<tbody>
								{listaContaEntrada.map((contaentrada, i) => {
									return (
										<tr key={i} className="zebra-row">
											<td className="col-3">
												<small>{contaentrada.descricao}</small>
											</td>
											<td className="col-1">
												<small>{contaentrada.valor}</small>
											</td>
											<td className="col-1" onClick={(e) => clickReceive(contaentrada)}>
												{contaentrada.ativo == "NAO" ? (
													<div className="badge_status bg_green">
														<small>Pago</small>
													</div>
												) : null}

												{contaentrada.ativo == "SIM" && contaentrada.statuspg != "ATRASADO" ? (
													<div className="badge_status bg_yellow">
														<small>À Vencer</small>
													</div>
												) : null}
												{contaentrada.ativo == "SIM" && contaentrada.statuspg === "ATRASADO" ? (
													<div className="badge_status bg_red">
														<small>Atrasado</small>
													</div>
												) : null}
											</td>
											<td className="col-1" onClick={(e) => clickRegister(contaentrada)}>
												{contaentrada.status == "ATIVO" ? (
													<div className="badge_status bg_green">
														<small>Ativo</small>
													</div>
												) : null}
												{contaentrada.status == "BLOQUEIO" ? (
													<div className="badge_status badge_status bg_red">
														<small>Bloqueado</small>
													</div>
												) : null}
												{contaentrada.status == "B.TEMPORÁRIO" ? (
													<div className="badge_status badge_status bg_yellow">
														<small>B.Temporário</small>
													</div>
												) : null}
												{contaentrada.status == "ATRASADO" ? (
													<div className="badge_status badge_status bg_yellow">
														<small>Atrasado</small>
													</div>
												) : null}
												{contaentrada.status == null ? (
													<div className="badge_status badge_status bg_silver">
														<small>N.Autorizado</small>
													</div>
												) : null}
											</td>
											<td className="col-1">
												<small>{functions.dateByString(contaentrada.data)}</small>
												{/* <small>{new Intl.DateTimeFormat("pt-br", { style: "short" }).format(Date.parse(contaentrada.data))}</small> */}
											</td>
											<td className="col-1">
												<small>{functions.dateByString(contaentrada.datavenda)}</small>
												{/* <small>{new Intl.DateTimeFormat("pt-br", { style: "short" }).format(Date.parse(contaentrada.data))}</small> */}
											</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>
				)}
			</div>
		</>
	);
}

export default ListContaEntradaSZ;
